{
  "trainingHist": {
    "labels": {
      "requests": "درخواست‌ها",
      "registered": "ثبت‌نام شده‌ها",
      "finished": "سپری شده‌ها",
      "requestDate": "تاریخ درخواست",
      "pending": "در انتظار بررسی",
      "approved": "تایید شده",
      "expired": "منقضی شده",
      "rejected": "رد شده",
      "present": "حاضر",
      "absent": "غایب",
      "teacher": "مدرس",
      "eventDate": "تاریخ برگزاری",
      "method": "شیوه اجرا",
      "location": "محل برگزاری"
    }
  },
  "homePage": {
    "labels": {
      "cancel": "لغو",
      "seeAll": "مشاهده همه",
      "notifs": "اعلان ها",
      "messages": "پیام ها"
    },
    "messages": {
      "noNotifications": "هیچ اعلانی جهت نمایش وجود ندارد.",
      "noMessages": "هیچ پیامی جهت نمایش وجود ندارد."
    }
  },
  "message": {
    "detail": "جزئیات پیام",
    "subject": "موضوع پیام",
    "title": "عنوان",
    "content": "متن پیام",
    "sendDate": "زمان ارسال پیام"
  },
  "labels": {
    "addToCalendar": "افزودن به تقویم"
  }
}
